<div class="modal-header">
  <div>
    <h5 class="modal-title mb-0">
      {{ formId ? 'ფორმის რედაქტირება' : 'ფორმის შექმნა' }}
    </h5>
    <div class="text-muted small">
      აირჩიე რომელ ფორმის გვერდს ეკუთვნის ეს ფორმა და შემდეგ დაამატე ველები.
    </div>
  </div>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <app-spinner [loading]="loading" text="იტვირთება..."></app-spinner>

  <form [formGroup]="form" *ngIf="!loading">
    <div class="row g-3">

      <!-- menu_page select -->
      <div class="col-md-4">
        <div class="form-floating">
          <select class="form-select" id="menuPageSelect" formControlName="menu_page">
            <option [ngValue]="null" disabled>აირჩიე ფორმის გვერდი</option>
            <option *ngFor="let p of pages" [ngValue]="p.menu_page">
              {{ p.title }} 
              <!-- ({{ p.menu_page }}) -->
            </option>
          </select>
          <label for="menuPageSelect">ფორმის გვერდი</label>
        </div>
        <div class="text-muted small mt-1" *ngIf="form.value.menu_page">
          <!-- არჩეული: <b>{{ form.value.menu_page }}</b> -->
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-floating">
          <input class="form-control" id="titleInput" formControlName="title" placeholder="სათაური" />
          <label for="titleInput">სათაური</label>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-floating">
          <input class="form-control" id="subjectInput" formControlName="subject" placeholder="სათაური მეილში" />
          <label for="subjectInput">სათაური მეილში</label>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-floating">
          <input
            class="form-control"
            id="recipientEmailsInput"
            formControlName="recipient_emails"
            placeholder="contact&#64;sca.ge, info&#64;sca.ge"
          />
          <label for="recipientEmailsInput">მიმღები მეილები (comma-separated)</label>
        </div>
        <div class="text-muted small mt-1">
           მაგალითად: <code>contact&#64;sca.ge, info&#64;sca.ge</code>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-floating">
          <textarea class="form-control" id="successMessageTextarea" style="height:50px" formControlName="success_message"></textarea>
          <label for="successMessageTextarea">Success ტექსტი</label>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-floating">
          <select class="form-select" formControlName="layout">
            <option [ngValue]="1">კონტენტი ზემოთ, ფორმა ქვემოთ</option>
            <option [ngValue]="2">ფორმა ზემოთ, კონტენტი ქვემოთ</option>
            <option [ngValue]="3">კონტენტი მარცხნივ, ფორმა მარჯვნივ</option>
            <option [ngValue]="4">ფორმა მარცხნივ, კონტენტი მარჯვნივ</option>
          </select>
          <label>განლაგება</label>
        </div>
      </div>

      <div class="col-12">
        <app-text-editor formControlName="content_html"></app-text-editor>
      </div>

      <!-- <div class="col-md-4">
        <div class="form-floating">
          <select class="form-select" id="positionSelect" formControlName="form_position">
            <option [ngValue]="1">Top</option>
            <option [ngValue]="2">Bottom</option>
            <option [ngValue]="3">Custom</option>
          </select>
          <label for="positionSelect">Form Position</label>
        </div>
      </div> -->

      <div class="col-md-4">
        <div class="form-floating">
          <select class="form-select" id="allowFilesSelect" formControlName="allow_files">
            <option [ngValue]="0">არა</option>
            <option [ngValue]="1">კი</option>
          </select>
          <label for="allowFilesSelect">Allow files</label>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-floating">
          <input class="form-control" id="maxFileMbInput" type="number" formControlName="max_file_mb" placeholder="10" />
          <label for="maxFileMbInput">Max file (MB)</label>
        </div>
      </div>

    </div>

    <div class="mt-3 d-flex flex-wrap gap-2 align-items-center">
      <button class="btn btn-primary" type="button" (click)="saveForm()" [disabled]="saving">
        <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
        შენახვა
      </button>

      <button class="btn btn-outline-secondary" type="button" (click)="openAddField()" [disabled]="!formId">
        + ველის დამატება
      </button>

      <span class="text-muted small" *ngIf="!formId">
        ჯერ ფორმა შეინახე, შემდეგ დაამატებ ველებს
      </span>

      <span class="text-muted small" *ngIf="sorting">
        სორტირება ინახება...
      </span>
    </div>
  </form>

  <hr class="my-4" />

  <!-- Fields -->
  <div *ngIf="formId && !loading">
    <h6 class="mb-2">ველები</h6>

    <div class="table-responsive" *ngIf="fields.length; else noFields">
      <table class="table table-bordered table-hover align-middle">
        <thead>
          <tr>
            <th style="width:50px;">#</th>
            <th style="width:50px;">⇅</th>
            <th>Label</th>
            <th>Type</th>
            <th style="width:120px;">Required</th>
            <th style="width:170px;">ქმედება</th>
          </tr>
        </thead>

        <tbody cdkDropList [cdkDropListData]="fields" (cdkDropListDropped)="drop($event)">
          <tr *ngFor="let f of fields; let i = index" cdkDrag>
            <td>{{ i + 1 }}</td>
            <td class="text-center" style="cursor:grab;">
              <span cdkDragHandle title="გადმოათრიე სორტირებისთვის">☰</span>
            </td>
            <td class="fw-medium">{{ f.label }}</td>
            <td><code>{{ f.type }}</code></td>
            <td>{{ f.required == 1 ? 'კი' : 'არა' }}</td>
            <td>
              <button class="btn btn-sm btn-outline-primary me-2" (click)="openEditField(f)">Edit</button>
              <button class="btn btn-sm btn-outline-danger" (click)="deleteField(f)">Delete</button>
            </td>
          </tr>
        </tbody>

      </table>
    </div>

    <ng-template #noFields>
      <div class="text-muted">ჯერ ველები არ გაქვს დამატებული</div>
    </ng-template>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-light" (click)="activeModal.dismiss()">დახურვა</button>
  <button class="btn btn-success" (click)="activeModal.close(true)">მზადაა</button>
</div>